import { Helmet } from 'react-helmet-async';
import { EditVuonTrongView } from 'src/sections/vuontrong/view';

// ----------------------------------------------------------------------

export default function VuongTrongEditPage() {
  return (
    <>
      <Helmet>
        <title>Chỉnh sửa vườn trồng - Hệ thống</title>
      </Helmet>
      <EditVuonTrongView />
    </>
  );
}
